<div class="user-profile-popup">
  <!-- Fixed Header Section -->
  <div class="popup-fixed-header">
    <button
      (click)="onClose()"
      class="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white shadow-card hover:bg-gray-50 transition-all duration-200 cursor-pointer z-50 text-dark-text"
    >
      <ic-close
        [height]="12"
        [width]="12"
        startColor="var(--color-primary-end-color)"
        endColor="var(--color-primary-start-color)"
      ></ic-close>
    </button>

    <!-- Header Section with Banner -->
    <div class="profile-banner relative">
      <!-- Background and Map Container (to handle clipping of background layers only) -->
      <div class="absolute inset-0 rounded-t-[12px] overflow-hidden">
        <!-- Background Color Layer -->
        <div class="absolute inset-0 bg-highlight-bg opacity-0.1"></div>

        <!-- World Map Layer -->
        <app-world-map
          class="absolute inset-0 w-full h-full pointer-events-none"
          color="var(--color-primary-end-color)"
          [opacity]="0.05"
        ></app-world-map>
      </div>

      <!-- Single-row: Avatar + Name/Role/Email -->
      <div class="relative z-20 flex items-center gap-4 px-sm py-6">
        <div
          class="w-12 h-12 shrink-0 rounded-full bg-white flex items-center justify-center shadow-card"
        >
          <ic-user
            startColor="var(--color-primary-end-color)"
            endColor="var(--color-primary-start-color)"
            [opacity]="0.8"
            [height]="26"
            [width]="26"
          ></ic-user>
        </div>
        <div class="flex flex-col min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="text-md font-semibold text-dark-text leading-tight">{{
              userName()
            }}</span>
            <span
              class="px-2 py-0.5 rounded-md bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-wider border border-primary/20 shrink-0"
            >
              {{ userRole() }}
            </span>
          </div>
          <p class="text-xs font-semibold text-gray-text truncate mt-xs">
            {{ userEmail() }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Scrollable Content Section -->
  <div class="popup-scroll-content h-[calc(100dvh-150px)] pt-sm">
    <div class="flex flex-col px-sm gap-sm">
      <!-- Company Profile -->
      @if (hasCompanyProfile()) {
      <button
        (click)="onCompanyProfile()"
        class="w-full flex items-center justify-between px-4 py-4 border border-line rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
      >
        <span class="text-sm font-medium text-gray-text">
          {{ 'companyProfile' | translate }}
        </span>
      </button>
      }

      <!-- User Profile -->
      <button
        (click)="onUserProfile()"
        class="w-full flex items-center justify-between bg-white px-4 py-4 border border-line rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
      >
        <span class="text-sm font-medium text-gray-text">{{
          'userProfile' | translate
        }}</span>
      </button>

      <!-- Theme Settings -->
      <button
        (click)="onThemeSettings()"
        class="w-full flex items-center justify-between bg-white px-4 py-4 border border-line rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
      >
        <span class="text-sm font-medium text-gray-text">{{
          'themeSettings' | translate
        }}</span>
      </button>

      <!-- Recent Downloads -->
      <button
        (click)="onRecentDownloads()"
        class="w-full flex items-center justify-between bg-white px-4 py-4 border border-line rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
      >
        <span class="text-sm font-medium text-gray-text">{{
          'recentDownloads' | translate
        }}</span>
      </button>

      <!-- Keyboard Shortcuts -->
      <button
        (click)="onKeyboardShortcuts()"
        class="w-full flex items-center justify-between bg-white px-4 py-4 border border-line rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
      >
        <span class="text-sm font-medium text-gray-text">{{
          'keyboardShortcuts' | translate
        }}</span>
      </button>

      <!-- API Reference Docs -->
      <button
        (click)="onViewApiReferenceDocs()"
        class="w-full flex items-center justify-between bg-white px-4 py-4 border border-line rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
      >
        <span class="text-sm font-medium text-gray-text">{{
          'viewApiReferenceDocs' | translate
        }}</span>
      </button>

      <!-- Change Password -->
      <button
        (click)="onChangePassword()"
        class="w-full flex items-center justify-between bg-white px-4 py-4 border border-line rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
      >
        <span class="text-sm font-medium text-gray-text">{{
          'changePassword' | translate
        }}</span>
      </button>

      <!-- Logout -->
      <button
        (click)="onLogout()"
        class="w-full flex items-center justify-between bg-white px-4 py-4 border border-line rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
      >
        <span class="text-sm font-medium text-gray-text">{{
          'logout' | translate
        }}</span>
      </button>
    </div>

    <div class="py-sm text-center">
      <span class="text-xs text-gray-text font-medium"
        >{{ 'version' | translate }} {{ appVersion }}</span
      >
    </div>
  </div>
</div>
